import React from "react";
import Services from "../Services";
import { indiaCatalog } from "../../utils/catalogSources";

/** India "Services" page: the Australian Services page on India data (₹). */
const IndiaServices = () => <Services catalog={indiaCatalog} />;

export default IndiaServices;
